function hello() {
    return "hello";
}